import { render, staticRenderFns } from "./ed-course-template-section.component.vue?vue&type=template&id=0c274223&scoped=true&"
import script from "./ed-course-template-section.component.ts?vue&type=script&lang=ts&"
export * from "./ed-course-template-section.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-course-template-section.component.scss?vue&type=style&index=0&id=0c274223&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c274223",
  null
  
)

export default component.exports